import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { UIRouterModule } from '@uirouter/angular';

import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { CheckboxAngularModule } from 'rev-shared/ui/checkbox/CheckboxAngular.Module';
import { CssRulesAngularModule } from 'rev-shared/ui/css/Css.AngularModule';
import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';
import { DialogAngularModule } from 'rev-shared/ui/dialog/DialogAngular.Module';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { FormDirectivesAngularModule } from 'rev-shared/util/directives/form/FormDirectivesAngular.Module';
import { FormGroupAngularModule } from 'rev-shared/ui/formGroup/FormGroupAngular.Module';
import { PipesAngularModule } from 'rev-shared/pipes/Pipes.AngularModule';
import { SidebarLayoutModule } from 'rev-shared/ui/sidebarLayout/SidebarLayout.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { TextInputAngularModule } from 'rev-shared/ui/text-input/TextInputAngular.Module';
import { VbProfilePictureModule } from 'rev-shared/ui/profile/VbProfilePicture.Module';
import { VbTextAreaModule } from 'rev-shared/ui/textArea/VbTextArea.Module';
import { VbUiSidebarNotificationIconComponent } from 'rev-shared/ui/sidebarLayout/VbUiSidebarNotificationIcon.Component';
import { VbUiToggleContentDisplayAngularModule } from 'rev-shared/ui/toggleContentDisplay/VbUiTogleContentDisplay.AngularModule';
import { VbWebcastBannerModule } from 'rev-shared/webcast/webcastView/banners/VbWebcastBanner.Module';
import { VbWebcastEmbeddedContentModule } from 'rev-shared/webcast/webcastView/embeddedContent/VbWebcastEmbeddedContent.Module';

import { BrandingAngularModule } from 'rev-portal/branding/BrandingAngular.Module';
import { EditWebcastAngularModule } from 'rev-portal/scheduledEvents/editWebcast/EditWebcastAngular.Module';
import { PresentationAngularModule } from 'rev-portal/scheduledEvents/presentations/PresentationAngular.Module';
import { ScheduledEventsCommonModule } from 'rev-portal/scheduledEvents/common/ScheduledEventsCommon.AngularModule';
import { ValidationAngularModule } from 'rev-shared/ui/validation/ValidationAngular.Module';
import { ValidationModule } from 'rev-shared/util/directives/form/validation/Validation.AngularModule';
import { WebcastAttendeesModule } from 'rev-portal/scheduledEvents/webcast/attendees/WebcastAttendees.Module';
import { WebcastNavModule } from 'rev-portal/scheduledEvents/webcast/nav/WebcastNav.Module';
import { WebcastSharedComponentsModule } from 'rev-portal/scheduledEvents/webcast/sharedComponents/WebcastSharedComponents.Module';

import { ProducerModule } from './producer/ProducerModule';
import { SelfProducedModule } from './selfProduced/SelfProduced.Module';
import { VbWebcastInfoSidebarComponent } from './VbWebcastInfoSidebar.Component';
import { VbWebcastPlayerModule } from '../webcastPlayer/VbWebcastPlayer.Module';
import { VbWebcastPollsModule } from './polls/VbwebcastPolls.Module';
import { VbWebcastQuestionsModule } from './questions/VbWebcastQuestions.Module';
import { VbWebcastVideoComponent } from './VbWebcastVideo.Component';
import { VbWebcastViewComponent } from './VbWebcastView.Component';
import { WebcastChatModule } from './chat/WebcastChat.Module';
import { WebcastStartAndEndMessageModule } from './startAndEndMessage/WebcastStartAndEndMessage.Module';
import { WebcastViewSidebarPanelComponent } from './WebcastViewSidebarPanel.Component';
import { VbWebcastVodPreview } from './VbWebcastVodPreview.Component';
import { VideoPlayerAngularModule } from 'rev-shared/videoPlayer/VideoPlayerAngular.Module';
import { VbWebcastDtmfSidebarComponent } from './VbWebcastDtmfSidebar.Component';
import { VbWebcastVodTimer } from './VbWebcastVodTimer.Component';

const components = [
	VbWebcastDtmfSidebarComponent,
	VbWebcastInfoSidebarComponent,
	VbWebcastVideoComponent,
	VbWebcastViewComponent,
	VbWebcastVodPreview,
	VbWebcastVodTimer,
	WebcastViewSidebarPanelComponent
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		BrandingAngularModule,
		BsDropdownModule,
		ButtonsAngularModule,
		CheckboxAngularModule,
		CommonModule,
		CssRulesAngularModule,
		DateAngularModule,
		DialogAngularModule,
		DirectivesAngularModule,
		EditWebcastAngularModule,
		FormDirectivesAngularModule,
		FormGroupAngularModule,
		FormsModule,
		PipesAngularModule,
		PresentationAngularModule,
		ProducerModule,
		ReactiveFormsModule,
		ScheduledEventsCommonModule,
		SelfProducedModule,
		SidebarLayoutModule,
		SpinnerAngularModule,
		TextInputAngularModule,
		TooltipModule,
		TranslateModule,
		UIRouterModule,
		ValidationAngularModule,
		ValidationModule,
		VbProfilePictureModule,
		VbTextAreaModule,
		VbUiSidebarNotificationIconComponent,
		VbUiToggleContentDisplayAngularModule,
		VbWebcastBannerModule,
		VbWebcastEmbeddedContentModule,
		VbWebcastPlayerModule,
		VbWebcastPollsModule,
		VbWebcastQuestionsModule,
		VideoPlayerAngularModule,
		WebcastAttendeesModule,
		WebcastChatModule,
		WebcastNavModule,
		WebcastSharedComponentsModule,
		WebcastStartAndEndMessageModule
	]
})
export class VbWebcastViewModule {}
